import android from "./android";
import ios from "./ios";
import linux from "./linux";
import macos from "./macos";
import mikrotik from "./mikrotik";
import windows7 from "./windows7";
import windows10 from "./windows10";
import xiaomi from "./xiaomi";
import GuidesInfo from "./guides.json";

export default {
  android,
  ios,
  linux,
  macos,
  mikrotik,
  windows7,
  windows10,
  xiaomi,
  GuidesInfo,
};
